/**
 * سجلّ «زرّ الرجوع يغلق النافذة» على شاشات اللمس (2026-10-08) — مشترك بين `TouchSelectPicker`
 * و`BackToCloseManager` كي لا يتعارضا على حدث popstate واحد.
 *
 * - `pushBackEntry(tag)`: يضيف سجلّ تاريخ **يحمل حالة Next.js نفسها** (`...history.state`) — سجلّ
 *   بلا مفاتيح Next (`__NA` …) يجعل الموجّه يعيد تحميل الصفحة كاملة إن رجع إليه المتصفّح.
 * - `popOwnEntry()`: نافذة أُغلقت بزرّها لا بالرجوع ⇒ نسحب سجلّها، ونعلّم popstate الناتج «لا تتصرّف».
 * - `consumeSkip()`: يُسأل في أوّل معالج popstate؛ صالح 600ms فقط (بيئة لا تطلق popstate — jsdom —
 *   لا تُبقي علامة معلّقة تبتلع رجوعًا حقيقيًّا بعد ذلك).
 */
let skipUntil = 0;

export function touchEnabled(force?: boolean): boolean {
  if (force) return true;
  try {
    if (localStorage.getItem("mc-touch-select") === "force") return true;
  } catch {}
  return typeof window !== "undefined" && !!window.matchMedia?.("(pointer: coarse)").matches;
}

export function pushBackEntry(tag: string) {
  const prev = (history.state && typeof history.state === "object") ? history.state : {};
  history.pushState({ ...prev, mcBack: tag }, "");
}

export function isOwnEntry(): boolean {
  return !!(history.state && typeof history.state === "object" && (history.state as Record<string, unknown>).mcBack);
}

export function popOwnEntry() {
  skipUntil = Date.now() + 600;
  history.back();
}

export function consumeSkip(): boolean {
  if (Date.now() < skipUntil) {
    skipUntil = 0;
    return true;
  }
  return false;
}
